export default __webpack_public_path__ + "static/media/erp.7be7fb71.svg";